module.exports = __webpack_public_path__ + "img/tool4.cfcfe105.png";